import React, { useEffect } from 'react';
import store from "../../storeWire";
import { system_notification } from "../../store/slice/system";
import { useForm } from 'react-hook-form';
import Quote from "@system/config/quote";
import { useQuoteStore } from "../../hooks/quote";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import System from 'src/helper/system';
import { DatePicker } from 'rsuite';
import isBefore from 'date-fns/isBefore';
import Helper from 'src/support/Helper';
import ReusableDiv from 'src/support/ReusableDiv';
import { useAuthStore } from "../../hooks/auth";
import { __remove, __set } from 'src/store/axios_indicator';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';

export function QuoteHeaderDetail() {
    const [__check] = useAxiosIndicatorCheck();
    const [_check_p] = useCheckAuthPermissions();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [{openQuoteList, quoteReasonList }, { fetch_open_quote_list,get_quote_reason_list}, { submit_quote }] = useQuoteStore(); // done
    const [{ }, { get_customer_scope_information }] = useAuthStore();
    useEffect(() => {
        // 11360
        async function fetchHere() {
            await get_quote_reason_list()
        }
        if (quoteReasonList && quoteReasonList?.length === 0)
            fetchHere();
    }, []);

    //By Ramya [Quote submission - Quote Arr]
    useEffect(() => {
        async function fetchOpenList() {
            await fetch_open_quote_list({
                "top": 20,
                "skip": Helper.getSkipCount(1, 20),
            })
        }
         fetchOpenList()
        
    }, []);
     let quoteArr =[];
     if(openQuoteList.records){
         Object.entries(openQuoteList.records).map((data)=>{
             quoteArr.push(data[1])
         })
     }

    const onSubmit = async (e) => {
        if(_check_p('QT_BUY_NOW').status === false)
        {
            openContactUsPopup(true);
            return false;
        }
        __set('QUOTE_API_CALL');

        const res = await get_customer_scope_information();
        if (res?.payload?.isSuccessFull && res?.payload?.data?.order_block === false) {
            const result = await submit_quote(e);
            if (result?.isSuccessFull) {
                store.dispatch(system_notification({
                    name: 'SubmitQuotePopup',
                    data: { isOrderBlocked: false, quoteArr },
                }));
            }
        } else {
            store.dispatch(system_notification({
                name: 'SubmitQuotePopup',
                data: { isOrderBlocked: true, quoteArr },
            }));
        }

        __remove('QUOTE_API_CALL');
    }

    const speedBoatName = (System.auth('speedBoat') === 'T' ? 'Abacus' : System.auth('speedBoat') === 'B' ? 'EBV' : 'Silica')
    const openContactUsPopup = (val) => {
        store.dispatch(system_notification({
            name: 'ContactUsPopup',
            data: { restrict: val != undefined ? val : false },
        }));
    };

    return (
        <>
            <div id="main" className="">
                {ReusableDiv.QuoteHeader()}
                <div id="pcnquote-submit-page" className="pcn-page container">
                    <p>It helps to expedite your quote if we know a little more about your project.</p>
                    <div className="content-box container quote-detail-form">
                        <h3>Fill in the project details.</h3>
                        <span className="mb-2 d-block">Required Field (*)</span>
                        <form>
                            <div className=" bs5 row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="quoteReason" className='d-block'>Quote Reason*</label>
                                        <select className="form-control" id="quoteReason" {...register("quoteReason", { required: true })}>
                                            <option value="">Select a Quote Reason</option>
                                            {quoteReasonList && quoteReasonList.map((v, i) => (
                                                <option key={v.quoteReasonType} value={v.quoteReasonType}>{v.quoteReasonName}</option>
                                            ))}
                                        </select>
                                        <p className="error">{errors.quoteReason?.type === 'required' && "Select quote reason"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="customerQuoteReferenceNumber" className='d-block'>Quote Reference*</label>
                                        <input type="text" className="form-control" id="customerQuoteReferenceNumber" placeholder="Quote reference" maxLength={35}
                                            {...register("customerQuoteReferenceNumber", { required: true })}
                                        />
                                        <p className="error">{errors.customerQuoteReferenceNumber?.type === 'required' && "Enter quote reference"}</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="endCustomerName" className='d-block'>End Customer Name</label>
                                        <input type="text" className="form-control" id="endCustomerName" placeholder=" End Customer Name" maxLength={35}
                                            {...register("endCustomerName")}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="projectDetails" className='d-block'>Project Details</label>
                                        <input type="text" className="form-control" id="projectDetails" placeholder="Project Details" maxLength={60}
                                            {...register("projectDetails")}
                                        />
                                        <p className="error">{errors.projectDetails?.type === 'required' && "Project Details is required"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-3">
                                    <div className="form-group" >
                                        <label htmlFor="deadline" className='d-block'>Deadline</label>
                                        <DatePicker
                                            {...register('deadline')}
                                            format={Helper.getDatepickerFormat()}
                                            disabledDate={date => isBefore(date, new Date())}
                                            onSelect={(date, event) => setValue('deadline', date)}
                                            placeholder="Month DD, YYYY"
                                            editable={false}
                                            oneTap
                                        />
                                    </div>
                                </div>
                                <div className="col-5">
                                    <label>&nbsp;</label>
                                    <p className='mt-2'>{speedBoatName} will aim to meet your request where possible.</p>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="customerComments" className='d-block'>Comment</label>
                                        <textarea className="form-control" rows="5" id="customerComments" placeholder="Comment" maxLength={72}
                                            {...register("customerComments", { maxLength: 72 })}
                                        ></textarea>
                                        <p className="error">{errors.customerComments?.type === 'maxLength' && "Please enter a valid comment, Max character exceeded"}</p>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div className="pcn-line-divider"></div>
                        <div className="d-flex justify-content-between align-items-center">
                            <a href={Quote.getQuoteRouteURL()}><i className="fa fa-angle-left" aria-hidden="true"></i> Back to review quote</a>
                            <button className="bs5 btn btn-primary" data-toggle="modal" data-target="#submit-quote-Modal"
                                onClick={handleSubmit(onSubmit)}>
                                {__check('QUOTE_API_CALL').status &&
                                    <i className="fa fa-spinner fa-spin" />
                                }
                                {!__check('QUOTE_API_CALL').status &&
                                    <>SUBMIT QUOTE</>
                                }

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}